import React, { useEffect, useState } from "react";
import Switch from "@mui/material/Switch";
// import { axiosInstance, adminAxios } from "../axiosInstance";
import { notify } from "./toastify";
import { ToastContainer } from "react-toastify";

export default function BasicSwitches({
  status,
  id,
  api,
  requestType,
  instanceType,
  fetchLoyalty,
}) {
  const [checked, setChecked] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setChecked(Number(status) === 1);
  }, [status]);

  const handleState = async (id, checked) => {
    setLoading(true);
    const actionStatus = checked ? "deactivate" : "activate";
    try {
      const response = await instanceType[requestType](
        `${api}/${actionStatus}/${id}`
      );
      notify(response.data.message, "success");
      // console.log(`${!actionStatus} successful`);
      // console.log(response.data.data.is_active);
      const newValue = response?.data?.data?.is_active;
      setChecked(newValue);
      // handleCha/
    } catch (error) {
      // console.log("error fetching data", err);
      notify(error?.response?.data?.message || error?.message);
    } finally {
      // fetchData();
      fetchLoyalty();
      setLoading(false);
    }
  };

  // const handleChange = (event) => {
  //   setChecked(event.target.checked);
  // };
  return (
    <div>
      <Switch
        checked={checked}
        onChange={() => handleState(id, checked)}
        inputProps={{ "aria-label": "controlled" }}
        disabled={loading}
      />
    </div>
  );
}
